<template>
  <div class="login_bg _col_center" id="login">
    <div class="bg_img">
      <img
        src="@/assets/img/login_bg/homepage_bg.png"
        alt=""
        srcset=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="view_box">
      <div class="flot_box download_box">
        <div class="first_box">
          <i class="el-icon-menu"></i>
          <span class="download_text">{{ $t("lang.APP下载") }}</span>
        </div>
        <div class="hover_box">
          <div class="qrcode_container">
            <div class="qrcode_wrapper">
              <div class="qrcode_title">
                <span>{{ $t("lang.安卓版下载") }}</span>
              </div>
              <img
                src="@/assets/img/qrcode/android.png"
                alt="Android App"
                class="qrcode_img"
              />
              <p class="qrcode_tip">{{ $t("lang.扫描下载安卓版") }}</p>
            </div>
            <div class="interval"></div>
            <div class="qrcode_wrapper">
              <div class="qrcode_title">
                <span>{{ $t("lang.iOS版下载") }}</span>
              </div>
              <img
                src="@/assets/img/qrcode/ios.png"
                alt="iOS App"
                class="qrcode_img"
              />
              <p class="qrcode_tip">{{ $t("lang.扫描下载iOS版") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flot_box other_box">
        <div class="first_box">
          <i class="el-icon-menu"></i>
          <span class="download_text">{{ $t("lang.联系方式") }}</span>
        </div>
        <div class="hover_box">
          <div class="qrcode_container">
            <div class="qrcode_wrapper">
              <img
                src="@/assets/img/qrcode/whats.png"
                alt="Android App"
                class="qrcode_img"
              />
              <p class="xc_name">WhatsApp</p>
              <p class="xc_phone">+8617306833239</p>
            </div>
            <div class="interval"></div>
            <div class="qrcode_wrapper">
              <img
                src="@/assets/img/qrcode/wechat.png"
                alt="iOS App"
                class="qrcode_img qrcode_pad_img"
              />
              <p class="xc_name">WeChat</p>
              <p class="xc_phone">17306833239</p>
            </div>
            <div class="interval"></div>
            <p class="xc_email">Email: trade5@ytl-e.com</p>
          </div>
        </div>
      </div>
<!--      <div class="cons_box" @click="onClickOpenZHYD">-->
<!--        <div class="first_box">-->
<!--          <div class="icon-container">-->
<!--            <i class="el-icon-menu icon-enter"></i>-->
<!--            <i class="el-icon-s-promotion icon-exit"></i>-->
<!--          </div>-->
<!--          <span class="download_text">{{ $t("lang.智慧用电") }}</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="login_box _row_between">
      <img
        src="@/assets/img/login_bg/homepage_bg2.png"
        alt=""
        title=""
        srcset=""
        style="width: 46%; margin-left: 3%; padding: 2% 0"
      />
      <div class="form_box _col">
        <div class="top_title">
          <p class="font28 color_blue">{{ $t("lang.欢迎登入智电生态") }}</p>
        </div>
        <el-form
          style="width: 70%"
          :model="loginForm"
          :rules="loginFormRules"
          ref="loginFormRef"
          class="icon_set"
        >
          <!-- 错误提示 -->
          <div
            :class="[showInputError ? 'show_tips' : 'hide_tips', 'error_tips']"
          >
            <span :class="{ shake_text: isShaking }">
              {{ $t("lang.您输入的账号或密码有误请重新输入") }}
            </span>
          </div>
          <!-- 用户名 -->
          <el-form-item prop="phone" style="margin-bottom: 9%" class="username">
            <el-input
              v-model="loginForm.phone"
              :placeholder="$t('lang.请输入账号')"
              @keyup.enter.native="onLogin"
            >
              <div slot="prefix" class="icons popover_style">
                <i class="icon-zhanghao iconfont icon_user"></i>
                <span slot="reference" class="code" @click="onClickCode">{{
                  loginForm.areaCode
                }}</span>
              </div>
            </el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item prop="password" style="margin-bottom: 9%">
            <el-input
              v-model="loginForm.password"
              :type="eyes.open1 ? 'text' : 'password'"
              :placeholder="$t('lang.请输入密码')"
              @keyup.enter.native="onLogin"
            >
              <i
                slot="prefix"
                class="icon-mima1 iconfont"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-if="eyes.open1"
                class="icon-xianshi iconfont"
                @click="eyes.open1 = false"
                style="color: #d7dee3; font-size: 24px"
              ></i>
              <i
                slot="suffix"
                v-else
                class="icon-yincang iconfont"
                @click="eyes.open1 = true"
                style="color: #d7dee3; font-size: 24px"
              ></i>
            </el-input>
          </el-form-item>
          <!-- 中英文选择 -->
          <el-form-item prop="language" style="margin-bottom: 4%">
            <el-select
              v-model="languageValue"
              style="width: 100%"
              @change="languageChange"
            >
              <el-option
                v-for="item in languageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
              <i
                slot="prefix"
                class="icon-yuyanqiehuan iconfont"
                style="color: #d7dee3; font-size: 22px"
              ></i>
            </el-select>
          </el-form-item>
          <div class="login_bottom">
            <el-checkbox v-model="checked">{{
              $t("lang.记住密码")
            }}</el-checkbox>
          </div>
          <el-form-item class="btns">
            <el-button
              type="primary"
              @click="onLogin"
              :loading="loading"
              style="width: 293px; height: 40px"
              >{{ $t("lang.登录") }}</el-button
            >
          </el-form-item>
          <code-search-dialog
            @setAreaCode="setAreaCode"
            ref="codeSearchDialog"
          />
        </el-form>
      </div>
    </div>
    <reset-ask-dialog @onResetPwd="onResetPwd" ref="resetAskDialog" />
    <ContactModule />
    <el-dialog
      :title='$t("lang.更新公告")'
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center>
      <div>
        <span class="update-section">{{ $t("lang.更新内容信息1") }}</span>
        <span class="update-section-text" v-html='$t("lang.更新内容信息")'></span>
        <span class="update-section-text">{{ $t("lang.更新内容信息2") }}</span>
        <el-checkbox style="top: 15px" v-model="txChecked">{{ $t("lang.不再提醒") }}</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="iKnowClick">{{ $t("lang.我知道了") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CodeSearchDialog from "./dialog/code-search-dialog.vue";
import ResetAskDialog from "./dialog/reset-ask-dialog.vue";
import ContactModule from "./children/contact-module.vue";
export default {
  name: "Login",
  components: {
    CodeSearchDialog,
    ResetAskDialog,
    ContactModule,
  },
  data() {
    return {
      txChecked: false,
      eyes: {
        open1: false,
        open2: false,
        open3: false,
      },
      pwdForm: {
        password: "",
        passwordRe: "",
      },
      languageOptions: [
        { label: "简体中文", value: 0 },
        { label: "English", value: 1 },
      ],
      languageValue: 0,
      checked: false,
      loading: false,
      loginForm: {
        phone: "",
        password: "",
        areaCode: "+86",
      },
      loginFormRules: {
        phone: [
          {
            required: true,
            message: this.$t("lang.请输入账号"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("lang.请输入密码"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 15,
            message: this.$t("lang.长度在6到20个字符"),
            trigger: "blur",
          },
        ],
      },
      /**账号密码错误 */
      showInputError: false,
      isShaking: false,
      dialogVisible: false,
    };
  },
  created() {
    this.languageValue = this.$i18n.locale == "zh-CN" ? 0 : 1;
    this.showInputError = false;
    this.isShaking = false;
    this.onReadAccountPassword();
  },
  mounted() {
    if(!localStorage.getItem("hasViewedUpdate")){
      this.dialogVisible = true;
    }
  },
  methods: {
    ...mapActions({
      loginInV1: "ZD_LoginInV1",
      doLoginPhoneV1: "ZD_DoLoginPhone",
      doLoginUser: "ZD_DoLoginUser",
      passwordInfo: "ZD_SecurityPasswordInfo",
    }),
    async iPasswordInfo() {
      try {
        let res = await this.passwordInfo();
        if (res.success !== 1) throw new Error("");
        this.$store.commit("password/openFactorAuthent2", res.value === 1);
      } catch (e) {
        this.$store.commit("password/openFactorAuthent2", false);
      }
    },
    //   this.$refs[formName].resetFields();
    //第二次调用
    async nextLogin() {
      this.iPasswordInfo();
      try {
        //片区登录
        let res = await this.loginInV1({});
        if (res.success !== 1) return;
        this.$router.push("/deviceList");
        setTimeout(() => {
          this.$message({
            message: this.$t("lang.登录成功"),
            type: "success",
          });
        }, 300);
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    //第一次调用统一平台登入接口
    async onLogin() {
      try {
        await this.$refs["loginFormRef"].validate();
        this.loading = true;
        this.loginForm.successCheckType = 1;
        this.toDoLogin();
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async toDoLogin() {
      this.loginForm.lan = "zh";
      try {
        let res;
        if (this.isPhone()) res = await this.doLoginPhoneV1(this.loginForm);
        else {
          this.loginForm.account = this.loginForm.phone;
          res = await this.doLoginUser(this.loginForm);
        }
        if (res.success !== 1) {
          if (this.showInputError) this.startShake();
          else this.showInputError = true;
          return;
        }
        if (res.menuType !== 21) {
          this.$message({
            message: this.$t("lang.只支持房东登录"),
            type: "error",
          });
          return;
        }
        // 货币符号
        localStorage.setItem("monetary", res.currencyCode || "元");
        localStorage.setItem("nationId", res.nationId);
        // 用户信息
        const userInfo = {
          usertype: res.menuType,
          username: res.nickName,
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        //记住密码
        this.onSetAccountPassword();
        //token
        sessionStorage.setItem("token", res.httpAccessToken);
        //需要修改密码
        if (res.needChangePassword) {
          this.$refs.resetAskDialog.show();
          return;
        }
        this.nextLogin();
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    iKnowClick(){
      if(this.txChecked){
        localStorage.setItem("hasViewedUpdate" , "true");
      }
      this.dialogVisible = false;
    },
    startShake() {
      this.isShaking = true;
      setTimeout(() => {
        this.isShaking = false;
      }, 550);
    },
    //语言设置
    languageChange(e) {
      this.$i18n.locale = e == 1 ? "en-US" : "zh-CN";
      localStorage.setItem("i18nlanguage", this.$i18n.locale);
    },
    onClickCode() {
      this.$refs.codeSearchDialog.show();
    },
    setAreaCode(code) {
      this.loginForm.areaCode = code;
    },
    onResetPwd() {
      this.$router.push("/loginResetPwd");
    },
    isPhone() {
      return /^\d/.test(this.loginForm.phone);
    },
    //#region 记住密码功能
    onSetAccountPassword() {
      let tempData = {
        account: this.loginForm.phone,
        password: "",
        areaCode: "",
        checked: false,
      };
      if (this.checked) {
        tempData.password = this.loginForm.password;
        tempData.areaCode = this.loginForm.areaCode;
        tempData.checked = true;
      }
      localStorage.setItem("RecordPassword", JSON.stringify(tempData));
    },
    onReadAccountPassword() {
      let record = localStorage.getItem("RecordPassword");
      if (this.isnull(record)) return;
      record = JSON.parse(record);
      this.loginForm.phone = record.account || "";
      this.loginForm.password = record.password || "";
      this.loginForm.areaCode = record.areaCode || "+86";
      this.checked = record.checked || false;
    },
    //#endregion

    onClickOpenZHYD() {
      window.open("https://hk.wl-s.com:8098/#/login", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .update-section {
  display: block;
  line-height: 1.5;
  text-align: justify;
}
/deep/ .update-section-text {
  display: block;
  line-height: 1.5;
  text-align: justify;
  text-indent: 2em;
}
#login .t10 {
  top: 80px;
}
.view_box {
  position: absolute;
  top: 20px;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.other_box {
  margin-top: 20px;
  &:hover {
    height: 580px;
  }
  .qrcode_wrapper {
    margin-top: 15px;
  }
  .hover_box {
    height: 580px;
  }
  .xc_name {
    margin-top: 12px;
    color: white;
    font-size: 14px;
  }
  .xc_phone {
    margin-top: 6px;
    color: white;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .xc_email {
    margin: 30px 0;
    color: white;
    font-size: 14px;
  }
  .qrcode_pad_img {
    padding: 8px !important;
  }
}
.download_box {
  &:hover {
    height: 500px;
  }
  .hover_box {
    height: 500px;
  }
}
.cons_box {
  background: rgba(64, 158, 255, 0.08);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(64, 158, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.2), 0 4px 30px rgba(0, 0, 0, 0.1),
    inset 0 0 20px rgba(255, 255, 255, 0.1);
  width: 200px;
  height: 50px;
  margin-top: 20px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-color: rgba(64, 158, 255, 0.6);
    box-shadow: 0 0 25px rgba(64, 158, 255, 0.3), 0 4px 35px rgba(0, 0, 0, 0.2),
      inset 0 0 25px rgba(255, 255, 255, 0.2);
  }

  .first_box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-left: 20px;

    .icon-container {
      position: relative;
      width: 18px;
      height: 18px;
      margin-right: 6px;

      i {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 18px;
        color: white;
        transition: all 0.3s ease-in-out;
      }

      .icon-enter {
        opacity: 1;
        visibility: visible;
      }

      .icon-exit {
        opacity: 0;
        visibility: hidden;
      }
    }

    &:hover {
      .icon-enter {
        opacity: 0;
        visibility: hidden;
      }

      .icon-exit {
        opacity: 1;
        visibility: visible;
      }
    }

    .download_text {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 100%;
      transition: color 0.3s ease-in-out;
    }
  }
}
.flot_box {
  background: rgba(64, 158, 255, 0.08);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(64, 158, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.2), 0 4px 30px rgba(0, 0, 0, 0.1),
    inset 0 0 20px rgba(255, 255, 255, 0.1);

  width: 200px;
  height: 50px;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  &:hover {
    width: 300px;
    .first_box {
      display: none;
    }
    .hover_box {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition-delay: 0.15s; // 延迟多少秒开始淡入，等待容器展开完成
    }
  }
  .first_box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-left: 20px;
    .download_text {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 100%;
    }
    .el-icon-menu {
      font-size: 18px;
      color: white;
      margin-right: 6px;
    }
  }
  .hover_box {
    width: 300px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    pointer-events: none;
    .qrcode_container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      .interval {
        width: 80%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
      .qrcode_wrapper {
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .qrcode_title {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 12px;
          span {
            font-size: 16px;
            color: white;
          }
        }
        .qrcode_tip {
          margin-top: 8px;
          color: white;
          font-size: 12px;
        }
        .xc_name {
          margin-top: 12px;
          color: white;
          font-size: 14px;
        }
        .xc_phone {
          margin-top: 6px;
          color: white;
          font-size: 14px;
        }
        .qrcode_img {
          box-sizing: border-box;
          width: 140px;
          height: 140px;
          border: 1px solid #e1e4e8;
          border-radius: 8px;
          padding: 2px;
          background: white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          transition: transform 0.3s ease;

          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
.reset_password {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  .title {
    font-size: 29px;
    color: #409eff;
    margin-bottom: 10px;
  }
  .text1 {
    font-size: 14px;
    color: #999999;
  }
  .input_icon {
    color: #d7dee3;
    font-size: 24px;
  }
}
.icon_set {
  position: relative;
  padding-top: 63px;
  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    15%,
    45%,
    75% {
      transform: translateX(-10px);
    }
    30%,
    60%,
    90% {
      transform: translateX(10px);
    }
  }
  .shake_text {
    animation: shake 0.5s ease-in-out;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
  .show_tips {
    opacity: 1;
  }
  .hide_tips {
    opacity: 0;
  }
  .error_tips {
    width: 100%;
    height: 32px;
    padding: 0 20px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #fc8b8b;
    transition: all 0.2s;

    position: absolute;
    top: 14px;
    left: 0;

    display: flex;
    align-items: center;
    font-size: 10px;
    color: white;
  }
  .username {
    /deep/ .el-input__inner {
      padding-left: 92px;
    }
  }
  .icons {
    display: flex;
    align-items: center;
    .code {
      display: inline-block;
      padding-left: 18px;
      padding-right: 12px;
      font-size: 16px;
      color: #409eff;
      cursor: pointer;
    }
  }
}
a {
  cursor: pointer;
}
#login {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.login_box {
  position: relative;
  width: 65%;
  background: white;
  position: absolute;
  border-radius: 10px;
  z-index: 1;
  .login_box_top {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -40%);
    display: flex;
    align-items: center;
    flex-direction: column;
    .avatar_box {
      width: 130px;
      height: 130px;
      border: 1px solid #eee;
      border-radius: 50%;
      padding: 10px;
      box-shadow: 0 0 10px #eee;
      background: rgb(250, 250, 250);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      img {
        width: 53.7%;
        height: 80%;
      }
    }
  }
}
.form_box {
  width: 70%;
  .top_title {
    width: 70%;
    text-align: left;
    margin-top: 7%;
  }
}
.btns {
  display: flex;
  justify-content: center;
  /deep/ .el-button--medium {
    font-size: 15px;
  }
}
.login_container {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.login_bg {
  width: 100%;
  height: 100%;
  position: relative;
}
.bg_img {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
}
.login_box_inner {
  margin: 60px 0px;
  padding: 0 30px;
}
.login_agree_text {
  font-size: 12px;
  color: #999;
}
.login_agree_article {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}
.login_agree_article :hover {
  color: rgb(0, 0, 0);
}
.login_bottom {
  margin-bottom: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-input__inner {
  border-radius: 0 4px 4px 0;
  border-bottom: 1px solid #ccc;
  border-top: none;
  border-left: none;
  border-right: none;
  color: #333;
  font-size: 16px;
  padding-left: 45px;
  padding-bottom: 10px;
}
/deep/.el-checkbox__label {
  color: #c1c9ce;
}
.icon_user {
  font-size: 26px;
  color: #d7dee3;
}
</style>
